/*
 * Copyright (c) 2025. Spin in het Web B.V. Apeldoorn.
 */

/*
 * basecomponent.ts
 * Interne basisklasse voor sihw-ngx components. Niet geëxporteerd.
 */

import {Directive, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs';
import {Sihwlog} from '../sihwlog';

@Directive()
export abstract class BaseComponent implements OnDestroy {
  protected log: Sihwlog;

  protected constructor(loglevel: string = 'warn') {
    this.log = new Sihwlog(loglevel, this.constructor.name);
  }
  private _subscriptions: Subscription[] = [];

  protected sub(s: Subscription): Subscription {
    this._subscriptions.push(s);
    return s;
  }

  ngOnDestroy() {
    for (const s of this._subscriptions) {
      s.unsubscribe();
    }
    this._subscriptions = [];
  }
}
